import { createPath, Link as RouterLink, LinkProps } from 'react-router'
import { INFLUENCER } from 'utils/constants/Helpers'
import useInfluencerFlow from './useCustomNavigate'

const Link = (linkProps: LinkProps) => {
  const { isInfluencerFlow } = useInfluencerFlow()
  const path =
    typeof linkProps.to === 'string' ? linkProps.to : createPath(linkProps.to)

  return (
    <RouterLink
      {...linkProps}
      to={isInfluencerFlow ? `${INFLUENCER}${path}` : path}
    >
      {linkProps.children}
    </RouterLink>
  )
}

export default Link
